module.exports = __webpack_public_path__ + "assets/icons/ic_visibility-5bff.svg";